import { Control, Controller, FieldPath, FieldValues } from "react-hook-form";
import { Checkbox } from "component-library";
import { PropsWithChildren } from "react";

type ControlledCheckBoxProps<F extends FieldValues, N> = {
  control: Control<F>;
  name: N;
  required?: boolean;
};

export const ControlledCheckbox = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: PropsWithChildren<ControlledCheckBoxProps<TFieldValues, TName>>,
) => {
  return (
    <Controller
      name={props.name}
      control={props.control}
      rules={{ required: props.required }}
      render={({ field, fieldState }) => (
        <Checkbox
          value={field.value}
          onChange={field.onChange}
          hasError={!!fieldState.error}
        >
          {props.children}
        </Checkbox>
      )}
    />
  );
};
